import { PageHeader } from '../components/PageHeader';
import { agentPersonas, orchestrationScores, taskTypes, toolConnectors } from '../lib/seedData';
import { ScoreBadge } from '../components/ScoreBadge';

export function DashboardPage() {
  const topScore = [...orchestrationScores].sort((a, b) => b.score - a.score)[0];

  return (
    <section className="page">
      <PageHeader title="Dashboard" description="Current orchestration library health and ranking coverage." />
      <div className="grid cols-3">
        <div className="card metric"><span>Agent personas</span><strong>{agentPersonas.length}</strong></div>
        <div className="card metric"><span>Tool connectors</span><strong>{toolConnectors.length}</strong></div>
        <div className="card metric"><span>Task types</span><strong>{taskTypes.length}</strong></div>
      </div>
      <div className="card" style={{ marginTop: 16 }}>
        <h2 className="section-title">Top score</h2>
        <p className="muted">{topScore.taskTypeId}</p>
        <ScoreBadge score={topScore.score} />
      </div>
    </section>
  );
}
